import { convertMousePointToLayerPoint } from '@/layers/main-layer/utils';
import { ILayerProps, IPoint } from '@/version-types';
import { IDrawInfo, IPathInfo, PenType, SelectionType } from '../types';

/**
 * 获取 SVG Path
 *
 * @param mousePoints - 鼠标点
 * @param closePath - 可选；是否关闭绘制路径；默认值为 `false`
 */
function pointsToPathDefine(mousePoints: IPoint[], closePath = false) {
    let d = '';
    mousePoints.forEach((item, index) => {
        if (index === 0) {
            d = `${d} M${item.x} ${item.y}  L ${item.x} ${item.y}`;
        } else {
            d = `${d} L ${item.x} ${item.y}`;
        }
    });
    if (closePath) {
        d += 'z';
    }
    return d;
}

function createBrushPath(
    mousePoints: IPoint[],
    strokeWidth: number,
    selectionType: SelectionType,
    drawEnd = false,
): IPathInfo {
    if (drawEnd) {
        return {
            d: pointsToPathDefine(mousePoints),
            stroke: selectionType === 'add' ? '#fff' : '#000',
            strokeWidth,
            strokeLineCap: 'round',
        };
    }

    return {
        d: pointsToPathDefine(mousePoints),
        stroke: selectionType === 'add' ? 'rgba(108, 142, 229, 0.6)' : 'rgba(255, 91, 75, 0.5)',
        strokeWidth,
        strokeLineCap: 'round',
    };
}

function createBoxPath(mousePoints: IPoint[], selectionType: SelectionType, drawEnd = false): IPathInfo {
    if (drawEnd) {
        return {
            d: pointsToPathDefine(mousePoints),
            fill: selectionType === 'add' ? '#fff' : '#000',
        };
    }

    return {
        d: pointsToPathDefine(mousePoints),
        fill: selectionType === 'add' ? 'rgba(108, 142, 229, 0.6)' : 'rgba(255, 91, 75, 0.5)',
    };
}

function createLassoPath(mousePoints: IPoint[], selectionType: SelectionType, drawEnd = false): IPathInfo {
    if (drawEnd) {
        return {
            d: pointsToPathDefine(mousePoints, drawEnd),
            fill: selectionType === 'add' ? '#fff' : '#000',
        };
    }

    return {
        d: pointsToPathDefine(mousePoints, drawEnd),
        stroke: selectionType === 'add' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(255, 91, 75, 0.5)',
        strokeWidth: 1,
    };
}

/**
 * 创建路径信息
 *
 * @param drawInfo - 绘制信息
 * @param drawEnd - 是否结束绘制
 * @returns 路径信息
 */
export function createPathInfo(drawInfo: IDrawInfo, drawEnd = false) {
    const { penType, points, penSize, selectionType: selectionType } = drawInfo;

    switch (penType) {
        case PenType.LASSO:
            return createLassoPath(points, selectionType, drawEnd);
        case PenType.BOX:
            return createBoxPath(points, selectionType, drawEnd);
        default: {
            return createBrushPath(points, penSize, selectionType, drawEnd);
        }
    }
}

export const createPathInfoWithPointConvert = (
    originLayer: ILayerProps,
    drawPathList: IDrawInfo[],
    drawEnd?: boolean,
) => {
    return drawPathList.map((drawInfo) => {
        return createPathInfo(
            {
                ...drawInfo,
                points: drawInfo.points.map((point) => convertMousePointToLayerPoint(originLayer, point)),
            },
            drawEnd,
        );
    });
};
